export default "__VITE_ASSET__1f6341f8__"